import React, { useState, useEffect } from "react";
import { Modal } from 'react-bootstrap';
import ReactPlayer from "react-player";

function VideoModal(props) {
    const [play, setPlayVideo] = useState(false);
    const [video, setVideo] = useState("");


    return (
        <React.Fragment>
            {props.video_url &&
                < div className="play-btn" onClick={e => {
                    setVideo(props.video_url)
                    setPlayVideo(true)
                }} >
                    {props.icon && props.icon == "light" ?
                        <i className="icon-play-light"></i>
                        :
                        <i className="icon-play"></i>
                    }

                </div>
            }

            {
                play && video &&
                <Modal
                    show={play}
                    onHide={() => setPlayVideo(false)}
                    dialogClassName="modal-video"
                    aria-labelledby="video-module"
                    backdropClassName="video-backdrop"
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <ReactPlayer
                            url={video}
                            playing={play}
                            controls={true}
                            width='100%'
                            height='100%'
                            //  onPlay={trackerVideo}
                            onEnded={() => { setPlayVideo(false) }}
                        />
                    </Modal.Body>
                </Modal>
            }


        </React.Fragment >
    )
}

export default VideoModal;